<template>
  <div>
    <div class="row mb-2">
      <div class="col-6" @click="$emit('close')">
        <h1 class="modal-h1 mb-3">
          <span class="btn btn-back" />
          Notifications
        </h1>
      </div>
      <div class="col-6 flex justify-content-end">
        <a href="#" class="mark-all-read" @click="markAllAsRead">
          Mark all as read
        </a>
      </div>
    </div>
    <template v-if="notifications === null">
      <div class="lds-ellipsis px-4 py-4">
        <div />
        <div />
        <div />
      </div>
    </template>
    <template v-else-if="notifications && notifications.length">
      <div>
        <div class="notification-wrap mt-2">
          <NotificationGroup
            v-for="(notification, index) in groupedNotifications"
            :key="index"
            :notifications="notification"
            @close="$emit('close')"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="notification-wrap mt-2">
        <span>
          There are no notifications right now.
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import _ from 'lodash';
import axios from 'axios';
import NotificationGroup from './NotificationGroup';

export default {
  components: {
    NotificationGroup,
  },
  computed: {
    ...mapState({
      user: state => state.auth.dispatchUser,
      notifications: state =>
        state.notifications.notifications ? state.notifications.notifications.data : null,
    }),
    groupedNotifications() {
      return _.sortBy(this.notifications, ['created_at'])
        .reverse()
        .reduce((result, notification) => {
          if (!notification.created_at) {
            return result;
          }

          result[notification.created_at.slice(0, -17)] =
            result[notification.created_at.slice(0, -17)] || [];
          result[notification.created_at.slice(0, -17)].push(notification);
          return result;
        }, {});
    },
  },
  created() {
    this.getNotifications();
  },
  methods: {
    ...mapActions(['getNotifications', '']),
    ...mapMutations(['markAllNotificationsAsRead']),
    markAllAsRead() {
      axios.post('/clusters/users/notifications', {}).then(() => {
        this.markAllNotificationsAsRead();
        this.getNotifications();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.mark-all-read {
  line-height: 2;
}
.lds-ellipsis {
  display: flex;
  justify-content: center;
  height: 10px;
}

.lds-ellipsis div {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin: 5px !important;
  background: #e3e3e3;
  animation: loader 0.6s infinite alternate;
}

.lds-ellipsis > div:nth-child(2) {
  animation-delay: 0.2s;
}

.lds-ellipsis > div:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes loader {
  to {
    opacity: 0.1;
    transform: translate(0, -20px);
    background: #e0e5ea;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Notifications.vue